export default {
  PRACTICES_TITLE: {
    title: 'Practices'
  },
  PRACTICES_ERROR: {
    title: 'There was an issue fetching practices'
  },
  PRACTICES_NO_DATA: {
    title: 'No practices were found for the selected patient'
  },
  PROVIDERS_TITLE: {
    title: 'Providers'
  },
  PROVIDERS_ERROR: {
    title: 'There was an issue fetching providers for the selected practice'
  },
  PROVIDERS_INIT: {
    title: 'Please select a practice to find providers'
  },
  PROVIDERS_NO_DATA: {
    title: 'No providers were found for the selected practice'
  },
  FIRST_AVAILABLE_TITLE: {
    title: 'Select First Available'
  },
  FIRST_AVAILABLE_ERROR: {
    title: 'There was an issue selecting the first available provider'
  },
  FIRST_AVAILABLE_SELECTION_ERROR: {
    severity: 'error' as 'error',
    title: 'First available provider failed',
    subtitle: 'Sorry, something went wrong selecting the first available provider.'
  },
  PROVIDER_SELECTION_ERROR: {
    severity: 'error' as 'error',
    title: 'Provider Selection Error',
    subtitle: 'There was an issue updating the provider selection'
  },
  PROVIDER_ERROR: {
    title: "There was an issue fetching the selected provider's details"
  },
  PROVIDER_COST_ERROR: {
    title: 'There was an issue fetching the estimated visit cost for the selected provider.'
  },
  PROVIDER_NO_DATA: {
    title: 'There are no details for the selected provider.'
  },
  SERVICE_KEY_TITLE: {
    title: 'Enter your service key'
  },
  SERVICE_KEY_INFO: {
    severity: 'info' as 'info',
    title: 'Service Key Info',
    subtitle:
      'You may receive a Service Key from your employer, health plan, or health care provider to activate a new service. It is optional and not required.'
  },
  // Provider Visibility
  AVAILABLE: {
    label: 'Online',
    color: 'success.main',
    value: 2
  },
  WAITING: {
    label: 'Busy',
    color: 'warning.main',
    value: 1
  },
  OFFLINE: {
    label: 'Offline',
    color: 'error.main',
    value: 0
  }
};
